import { PublicClientApplication, SilentRequest } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.CLIENT_ID, // Your Application (client) ID
    authority: process.env.LOGIN_URL, // For multi-tenant app
    redirectUri: window.location.origin, // Redirect URI configured in Azure portal
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false, // Recommended to set to true for IE 11
  },
};

export const loginRequest: SilentRequest = {
  scopes: [
    "User.Read",
    "openid",
    "profile",
    "User.ReadBasic.All",
    "offline_access",
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);
